import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ApiUrl } from "Services/Services";
import { toast } from "react-toastify";

const ViewOrder = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [isTimeUpdated, setIsTimeUpdated] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [estimatedTime, setEstimatedTime] = useState(10);
  const [isUpdating, setIsUpdating] = useState(false);

  const [riders, setRiders] = useState([]);
  const [selectedRider, setSelectedRider] = useState("");

  const mapRef = useRef(null);
  const printRef = useRef();

  // Fetch order details
  const fetchOrder = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/order/${id}`);
      setOrder(res.data.data);
      setIsTimeUpdated(false);
      setNewStatus(res.data.data.status);
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch riders for this branch
  const fetchRiders = async (branchId) => {
    try {
      const res = await axios.get(`${ApiUrl}/rider/activeRiders?branchId=${branchId}`);
      setRiders(res.data);
    } catch (err) {
      console.error("Failed to fetch riders", err);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [id]);

  useEffect(() => {
    if (order?.Branch?.id) {
      fetchRiders(order.Branch.id);
    }
  }, [order]);

  // Initialize Google Map
  useEffect(() => {
    function initMap() {
      if (order && order.latitude && order.longitude && mapRef.current) {
        const position = {
          lat: parseFloat(order.latitude),
          lng: parseFloat(order.longitude),
        };
        const map = new window.google.maps.Map(mapRef.current, {
          zoom: 15,
          center: position,
        });
        new window.google.maps.Marker({ position, map });
      }
    }

    if (!window.google && !document.querySelector("#google-maps-script")) {
      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyCzIs8v0y-Tw9f1v-MOQgObR_tROZgjBcE";
      script.id = "google-maps-script";
      script.async = true;
      script.defer = true;
      script.onload = initMap;
      document.body.appendChild(script);
    } else if (window.google) {
      initMap();
    }
  }, [order]);

  // Print slip
  const handlePrint = () => {
    window.print();
  };

  // Update order status
  const handleStatusChange = async () => {
    if (newStatus === order.status && !isTimeUpdated) return;

    try {
      setIsUpdating(true);
      const payload = { status: newStatus };
      if (isTimeUpdated) {
        payload.estimatedTime = estimatedTime;
      }
      await axios.put(`${ApiUrl}/order/${id}/status`, payload);
      toast.success("Order status updated successfully");
      fetchOrder();
      setIsTimeUpdated(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update order status");
    } finally {
      setIsUpdating(false);
    }
  };

  // Assign rider
  const handleAssignRider = async () => {
    if (!selectedRider) {
      toast.error("Please select a rider");
      return;
    }
    const payload = {
      riderId : selectedRider,
      orderId : id
    }
    try {
      console.log("assignRider payload:", { id, selectedRider, type: typeof id });

      await axios.post(`${ApiUrl}/rider/assign-rider`, payload);
      toast.success("Rider assigned successfully");
      fetchOrder();
    } catch (err) {
      console.error(err);
      toast.error("Failed to assign rider");
    }
  };

  if (!order) return <div className="p-6">Loading order details...</div>;

  const {
    User,
    Customer,
    items,
    Branch,
    totalPrice,
    status,
    address,
    notes,
    deliveryCharges = 0,
    tax = 0,
  } = order;

  const subtotal = totalPrice - deliveryCharges - tax;

  return (
    <div className="p-6 space-y-6">
      {/* Print CSS */}
      <style>{`
        .slip-only { display: none; }
        @media print {
          body * { visibility: hidden !important; }
          .slip-only, .slip-only * {
            visibility: visible !important;
            display: block !important;
          }
          .slip-only {
            position: absolute !important;
            top: 0; left: 0;
            width: 100%;
            padding: 20px;
            font-family: monospace;
            font-size: 14px;
            background: white;
          }
        }
      `}</style>

     {/* Assign Rider Section (only show when status is ready) */}
{newStatus === "ready" && (
  <div className="flex items-center space-x-4">
    <select
      value={selectedRider}
      onChange={(e) => setSelectedRider(e.target.value)}
      className="border border-gray-300 rounded-md px-3 py-2"
    >
      <option value="">Select Rider</option>
      {riders.map((rider) => (
        <option key={rider.id} value={rider.id}>
          {rider.name} - {rider.phone}
        </option>
      ))}
    </select>
    <button
      onClick={handleAssignRider}
      className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
    >
      Assign Rider
    </button>
  </div>
)}


      {/* Print + Update Controls */}
      <div className="flex items-center space-x-4">
        <button
          onClick={handlePrint}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Print Slip
        </button>
        <select
  value={newStatus}
  onChange={(e) => setNewStatus(e.target.value)}
  className="border border-gray-300 rounded-md px-3 py-2"
>
 <option value="pending">Pending</option>
<option value="accepted">Accepted</option>
<option value="preparing">Preparing</option>
<option value="ready">Ready</option>
<option value="assigned">Assigned</option>
{/* <option value="picked_up">Picked Up</option>
<option value="on_the_way">On the Way</option> */}
<option value="delivered">Delivered</option>
<option value="cancelled">Cancelled</option>

</select>
        <select
          value={estimatedTime}
          onChange={(e) => {
            setEstimatedTime(Number(e.target.value));
            setIsTimeUpdated(true);
          }}
          className="border border-gray-300 rounded-md px-3 py-2"
        >
          <option value={10}>10 mins</option>
          <option value={20}>20 mins</option>
          <option value={30}>30 mins</option>
          <option value={45}>45 mins</option>
          <option value={60}>60 mins</option>
        </select>
        <button
          onClick={handleStatusChange}
          disabled={isUpdating || newStatus === status}
          className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
        >
          {isUpdating ? "Updating..." : "Update Status"}
        </button>
      </div>

      {/* Order Details */}
      <div className="space-y-6">
        <h2 className="text-2xl font-bold">Order Details</h2>

        <div className="bg-white shadow rounded p-4 space-y-2">
          <p><strong>Branch Name:</strong> {Branch?.name || "N/A"}</p>
        </div>

     <div className="bg-white shadow rounded p-4 space-y-2">
  <p>
    <strong>Customer:</strong>{" "}
   {User?.name || Customer.name || "N/A"}
  </p>
  <p>
    <strong>Phone:</strong>{" "}
    {User?.phoneNumber || Customer.phone || "N/A"}
  </p>
  {/* {User?.id && (
    <p>
      <strong>User ID:</strong> {User.id}
    </p>
  )} */}
  {order.orderType === "dining" && (
    <p>
      <strong>Table Number:</strong> {order.Table.number || "N/A"}
    </p>
  )}
  <p><strong>Address:</strong> {address}</p>
  <p>
    <strong>Status:</strong> <span className="capitalize">{status}</span>
  </p>
  <p><strong>Notes:</strong> {notes}</p>
</div>


        <div className="bg-white shadow rounded p-4">
          <h3 className="text-lg font-semibold mb-2">Items</h3>
          <ul className="space-y-2">
            {items.map((item, i) => (
              <li key={i} className="border-b pb-2">
                <div><strong>Food:</strong> {item.food?.name || item.deal?.name}</div>
                <div><strong>Variation:</strong> {item.variation?.name|| 'N/A'}</div>
                <div>
                  <strong>Toppings:</strong>{" "}
                  {item.toppings?.length
                    ? item.toppings.map((t) => t.topping?.name + ' x ' + t.quantity).join(", ")
                    : "N/A"}
                </div>
                <div><strong>Quantity:</strong> {item.quantity}</div>
                <div><strong>Price:</strong> Rs {item.price}</div>
              </li>
            ))}
          </ul>
          <div className="mt-4 space-y-1 text-right">
            <p><strong>Subtotal:</strong> Rs {subtotal}</p>
            <p><strong>Delivery Charges:</strong> Rs {deliveryCharges}</p>
            <p><strong>Tax:</strong> Rs {tax}</p>
            <p className="font-bold text-lg"><strong>Total:</strong> Rs {totalPrice}</p>
          </div>
          <div className="mt-8 border-t pt-4 text-sm text-gray-700">
            <p><strong>Branch Location:</strong> {Branch?.address || "N/A"}</p>
            <p><strong>Branch Phone:</strong> {Branch?.phone || "N/A"}</p>
          </div>
        </div>
      </div>
 
      {/* Map */}
      <div ref={mapRef} className="w-full h-64 rounded shadow" />
    </div>
  );
};

export default ViewOrder;
